import { render, staticRenderFns } from "./parcelBlock.vue?vue&type=template&id=2441f99a"
import script from "./parcelBlock.vue?vue&type=script&lang=js"
export * from "./parcelBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports